import './ValidatedTextInput.scss';
import { TranslationKey } from '@Localization';
import { Textarea } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useRef } from 'react';
import { S_FieldError } from '../../design/errors/fieldError/S_FieldError';
import { S_FieldLabel } from '../../design/labels/fieldLabel/S_FIeldLabel';

interface IValidatedTextAreaProps {
  id?: string;
  labelText?: string;
  value?: string | number;
  maxLength?: number;
  placeholder?: string;
  onChange?(value: string): void;
  onBlur?(value: string): void;
  isValid?: boolean;
  feedbacks?: TranslationKey[];
  feedbacksParams?: Record<string, string | number>;
  isRequired?: boolean;
  className?: string;
  readOnly?: boolean;
  disabled?: boolean;
  autofocus?: boolean;
}

export const ValidatedTextArea = observer((props: IValidatedTextAreaProps): ReactElement => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (props.autofocus) {
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, []);

  return (
    <div className='validated-text-input'>
      {props.labelText && (
        <S_FieldLabel
          isRequired={props.isRequired}
          text={props.labelText}
        />
      )}
      <div className='validated-text-input-wrapper'>
        <Textarea
          slotProps={{
            textarea: {
              maxLength: props.maxLength ?? 100,
              ref: inputRef,
            },
          }}
          id={props.id}
          value={props.value !== null ? props.value : ''}
          error={props.isValid === false}
          placeholder={props.placeholder}
          onChange={(e) => props.onChange?.(e.target.value)}
          onBlur={(e) => props.onBlur?.(e.target.value)}
          required={props.isRequired}
          className={props.className}
          readOnly={props.readOnly}
          disabled={props.disabled}
        />
      </div>
      {props.feedbacks && (
        <S_FieldError
          feedbacks={props.feedbacks}
          feedbacksParams={props.feedbacksParams}
        />
      )}
    </div>
  );
});
